module.exports = __webpack_public_path__ + "static/media/majors-students-biology-university-of-arizona.4cac3710.jpg";